/**
 * Generates Analytics pageName from URL
 * @param appRoot
 * @param url
 * @returns string of pageName from URL
 */
export default function getPageNameFromUrl(appRoot, url) {
	let relativeUrl = url
		.replace(/.*\/myaccount\/(.*?)/, '$1')
		.replace(/\?.*/, '')

	// Creates consistent page name with or without /
	if (relativeUrl === appRoot + '/') {
		relativeUrl = relativeUrl.replace('/', '')
	}

	if (!relativeUrl) {
		relativeUrl = appRoot
	}
	return relativeUrl.replace(/\//g, ':')
}
